function Footer() {
  return (
    <div className="footer">
      <hr className="hr" style={{ marginLeft: "50px", marginRight: "50px" }} />
      <footer>
        <h4>Developed {"</>"} by Parth</h4>
      </footer>
    </div>
  );
}

export default Footer;
